<template>
  <div class="container">
    <div class="head">
        <div class="title">
          <div class="text">游客投诉率</div>
           <div class="head_right_complain">
              <div class="branch">-{{deduction}}</div>
              <div class="num">{{score}}/{{totalScore}}</div>
          </div>
          
        </div>
        <div class="tip">
          <div class="con">{{areaName}}</div>
          <div class="con">{{areaType == '1' ? '一' : '二'}}类地区</div>
        </div>
        <div class="date">{{quarterCN}}</div>
      </div>
    <div class="pg-pd12">
      <div>
           <causeDeduction  :causeContent="causeContent" causeTitle="扣分原因"></causeDeduction>
      </div>
      <div class="main">
        <div class="title">扣分详情</div>
        <div class="content">
          <div class="deduc-item">
            <div class="name">投诉量</div>
            <div class="cont">{{complainNum}}</div>
          </div>
          <div class="deduc-item">
            <div class="name">接待人次</div>
            <div class="cont">{{touristNum}}</div>
          </div>
          <!-- touristNum -->
          <div class="deduc-item">
            <div class="name">
              <div>万人投诉率</div>
              <div class="txt">投诉率=投诉量÷接待人次</div>
              <!-- <div class="txt">+有效已办结投诉件数</div> -->
            </div>
            <div class="cont">{{complainRate}}</div>
          </div>
          <div class="deduc-item">
            <div class="name">排名</div>
            <div class="cont">{{ranking}}</div>
          </div>
        </div>
      </div>
      <div class="complain" @click="goCompalinList">
        <span>查看投诉件列表</span>
      </div>
      <complainForm :tableList="tableList"></complainForm>
   </div>
  </div>
</template>
<script>
    import causeDeduction from '../../components/causeDeduction';// 扣分原因
    // import complainForm from '../components/form';// 表格
    import complainForm from '../components/complainForm';
    import api from '../../../../service/modules/appraiseNew';

    export default {
        components: {
            causeDeduction, complainForm
        },

        data () {
            return {
                causeContent: '',
                ranking: '',
                quarterCN: '',
                complainNum: '',
                touristNum: '',
                complainRate: '',
                deduction: '',
                cityId: '',
                areaName: '',
                areaType: '',
                tableList: [],
                totalScore: this.$route.query.totalScore,
                score: this.$route.query.score
            }
        },

        computed: {},

        watch: {},

        methods: {
            // 详情
            async queryDetail(){
              console.log('--刚进入页面的路由值:', this.$route.query);
              const { year, quarter, area} = this.$route.query;
              let params  = {
                year,
                quarter,
                area
              }
              let res = await api.touristComplain(params);
              if(res.ret === 0) {
                this.causeContent = res.data.deductionReason;
                this.ranking = res.data.ranking;
                this.quarterCN = res.data.quarterCN;
                this.complainNum = res.data.complainNum;
                this.touristNum = res.data.touristNum;
                this.complainRate = res.data.complainRate;
                this.deduction = res.data.deduction;
                this.tableList = res.data.areaTypeResVO;
                this.cityId = res.data.cityId;
                this.areaName = res.data.areaName;
                this.areaType = res.data.areaType;
              }
            },
            navTo () {
                this.$router.push({
                    path: '/appraise/scoreList'
                })
            },
            goCompalinList() {
              const { year, quarter, areaName} = this.$route.query;
              console.log('路由值：', this.$route.query);
              this.$router.push(`/complaint/checkList?type=retaList&areaOne=${this.cityId}&fullAdress=${areaName}&year=${year}&quarter=${quarter}`);
            }
        },

        mounted () {
        },

        created () {
          this.queryDetail();
        }

    }
</script>
<style scoped lang="less">
  .container {
    min-height: 100vh;
    background: rgba(251, 251, 251, 1);
    padding-bottom: 24px;
  .pg-pd12 {
      padding-left: 12px;
      padding-right: 12px;

    }
        .head{
          width: 100%;
          background: #fff;
          padding: 24px 12px;
          margin-bottom: 24px;
          .title{
            height:22px;
            line-height: 22px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .head_right_complain{
               text-align: right;
              margin-top: 22px;
            }
            .text{
              font-size:20px;
              font-family:PingFangSC-Medium,PingFang SC;
              font-weight:bold;
              color:rgba(51,51,51,1);
              line-height:20px;
            }
            .branch{
              height:22px;
              font-size:22px;
              font-family:DIN-Medium,DIN;
              font-weight:500;
              color:rgba(255,77,77,1);
              line-height:22px;
            }
            .num {
              font-size: 14px;
              font-family: DIN-Medium, DIN;
              font-weight: 500;
              color: rgba(153, 153, 153, 1);
              line-height: 22px;
              margin-top: 2px;
            }
        }
        .tip{
          margin-top:12px;
          display: flex;
          font-size:10px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(54,179,116,1);
          .con{
            border:1Px solid rgba(54,179,116,1);
            padding: 2px 4px;
            margin-right:14px;
          }
        }
        .date{
          margin-top:12px;
          font-size:12px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(153,153,153,1);
          line-height:12px;
        }
    }
.main{
      margin-top: 24px;
      .title{
        font-size:16px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:bold;
        color:rgba(51,51,51,1);
      }
      .content{
        background:rgba(255,255,255,1);
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
        border-radius:3px;
        margin-top: 12px;
        padding: 16px;
        .deduc-item{
          display: flex;
          justify-content: space-between;font-size:14px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          padding-bottom: 12px;
          .name{
            color: #999999;
            .txt{
              font-size:12px;
              margin-top: 4px;
            }
          }
          .cont{
            color: #333333;
          }
        }
        .deduc-item:last-child{
          padding-bottom: 0;
        }
      }
    }
.complain{
      position: relative;
      line-height:46px;
      background:rgba(255,255,255,1);
      box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
      border-radius:3px;
      padding: 0 16px;
      margin-top: 24px;
      font-size:16px;
      font-family:PingFangSC-Medium,PingFang SC;
      font-weight:bold;
      color:rgba(51,51,51,1);
    }
    .complain::after{
      content: '';
      position: absolute;
      right: 16px;
      top: 16px;
      width: 12px;
      height: 12px;
      background: url('../../../../assets/image/t-right.png') no-repeat;
      background-size: 12px 12px;
    }
  }
</style>
